import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppState } from '../hooks/useAppState';
import { adoptSession } from '../lib/api';
import { mockUser } from '../data/mockUser';
import { ICE, TEAL, PAGE, PX_FONT } from '../components/guild/theme';

/* Discord sends members back through the server, which lands them here with a session in the URL
   fragment (never sent to any server). Store it, set who they are, and go to Home Base. */
export function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAppState();
  const [error, setError] = useState<string | null>(null);
  const [welcome, setWelcome] = useState<{ name: string; role: string } | null>(null);
  const ran = useRef(false);
  useEffect(() => {
    if (ran.current) return; // the token is read once (dev StrictMode runs effects twice)
    ran.current = true;
    const h = new URLSearchParams(window.location.hash.slice(1));
    const token = h.get('token');
    if (!token) { setError('Login didn\'t complete. Try again from the home page.'); return; }
    adoptSession(token);
    const roles = (h.get('roles') ?? '').split(',').filter(Boolean);
    const role = roles.includes('inner_circle') ? 'Inner Circle' : 'Accelerator';
    try { localStorage.setItem('paladin-role', role); } catch { /* per-page only */ }
    setUser({ ...mockUser, discordUsername: h.get('name') || 'trader', role, traderStage: null, currentStrategy: null, currentFirmId: null, currentTier: null });
    // Drop the token from the address bar, greet them with what Discord actually told us, then move on
    window.history.replaceState(null, '', '/auth/callback');
    setWelcome({ name: h.get('name') || 'trader', role: roles.includes('admin') ? 'Moderator' : role });
    setTimeout(() => navigate('/hub', { replace: true }), 1800);
  }, [navigate, setUser]);
  if (welcome) {
    const badge = welcome.role === 'Accelerator' ? '#4A9EFF' : '#D4A843';
    return (
      <div style={{ minHeight: '100vh', background: PAGE, display: 'grid', placeItems: 'center', fontFamily: PX_FONT, textAlign: 'center' }}>
        <div>
          <div style={{ color: TEAL, fontSize: 11, letterSpacing: '0.12em', marginBottom: 10 }}>MEMBERSHIP VERIFIED</div>
          <div style={{ color: ICE, fontSize: 18, letterSpacing: '0.08em', marginBottom: 14 }}>WELCOME, {welcome.name.toUpperCase()}</div>
          <span style={{ background: badge, color: '#020A10', fontSize: 11, padding: '4px 10px', letterSpacing: '0.1em' }}>{welcome.role.toUpperCase()}</span>
        </div>
      </div>
    );
  }
  return (
    <div style={{ minHeight: '100vh', background: PAGE, display: 'grid', placeItems: 'center', fontFamily: PX_FONT, color: error ? ICE : TEAL }}>
      {error ?? 'Signing you in…'}
    </div>
  );
}
